import { FormattedMessage } from 'react-intl';
import styled, { CSSProperties } from 'styled-components';

import { DivisionChange } from '@sorare/core/src/__generated__/globalTypes';
import Button from '@sorare/core/src/atoms/buttons/Button';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL, DisplayL } from '@sorare/core/src/atoms/typography';
import { Img } from '@sorare/core/src/atoms/ui/Img';
import { useConnectionContext } from '@sorare/core/src/contexts/connection';
import { glossary } from '@sorare/core/src/lib/glossary';

import { DumbStatus } from '@sorare/gameplay/src/components/managerTeam/Status/DumbStatus';

import { Pictures } from 'components/landing/EarlyAccess/types';

const Root = styled(Vertical)`
  padding: calc(8 * var(--unit)) var(--double-unit);
  background-image: var(--backupField);
  background-image: var(--field);
  text-align: center;
  background-size: cover;
  background-position: center;
`;
const Header = styled(Vertical)`
  max-width: 392px;
`;
const Promotion = styled(Horizontal)`
  filter: drop-shadow(0px 0px 15px rgba(34, 255, 96, 0.7));
  font-size: 2em;
  p {
    text-shadow: 0px 0px 36px #22ff60;
  }
`;

export type CompeteAssets = {
  field: Pictures;
  cards: Pictures;
};
type Props = {
  assets: CompeteAssets;
};
export const Compete = ({ assets }: Props) => {
  const { signUp } = useConnectionContext();
  return (
    <Root
      gap={8}
      center
      style={
        {
          '--backupField': `url(${assets.field.pictureUrl})`,
          '--field': `image-set(url(${assets.field.avif}) type('image/avif'), url(${assets.field.pictureUrl}) type('image/jpeg'))`,
        } as CSSProperties
      }
    >
      <Header gap={3} center>
        <Vertical gap={2}>
          <DisplayL>
            <FormattedMessage
              id="landing.EarlyAccess.Compete.title"
              defaultMessage="Compete"
            />
          </DisplayL>
          <BodyL>
            <FormattedMessage
              id="landing.EarlyAccess.Compete.description"
              defaultMessage="Set 5-player lineups and compete in fantasy competitions across football’s top competitions."
            />
          </BodyL>
        </Vertical>
        <Button color="secondary" size="medium" onClick={signUp}>
          <FormattedMessage {...glossary.playNow} />
        </Button>
      </Header>
      <picture>
        <source srcSet={assets.cards.avif} type="image/avif" />
        <Img
          src={assets.cards.pictureUrl}
          fetchpriority="low"
          width="543"
          height="661"
        />
      </picture>
      <Promotion>
        <DumbStatus divisionChange={DivisionChange.PROMOTED} />
        <BodyL bold as="p">
          <FormattedMessage
            id="landing.EarlyAccess.Compete.promotion"
            defaultMessage="Promotion"
          />
        </BodyL>
        <Img
          src="https://frontend-assets.sorare.com/football/manager_team/limited-1-in/icon.png"
          fetchpriority="low"
          width="64"
          height="64"
        />
      </Promotion>
    </Root>
  );
};
